import {announce} from '@github-ui/aria-live'
import {useReopenPullRequestMutation} from '@github-ui/mergebox/use-reopen-pull-request-mutation'
import {GitPullRequestIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {FailureDialog} from './FailureDialog'
import {useInvalidatePrState} from '../data/use-invalidate-pr-state'
import {PullRequestState} from '../../../types'

export function ReopenAction() {
  const invalidatePrState = useInvalidatePrState()

  const reopenMutation = useReopenPullRequestMutation({
    onSuccess: () => {
      announce('Pull request reopened')
      invalidatePrState(PullRequestState.Open)
    },
  })

  return (
    <>
      <ActionList.Item loading={reopenMutation.isPending} onSelect={() => reopenMutation.mutate()}>
        <ActionList.LeadingVisual>
          <GitPullRequestIcon />
        </ActionList.LeadingVisual>
        Reopen pull request
      </ActionList.Item>

      {reopenMutation.isError && (
        <FailureDialog
          title="Failed to reopen pull request"
          message="An error occurred while reopening this pull request. Please try again."
          details={reopenMutation.error.message}
          onRetry={() => reopenMutation.mutate()}
          onDismiss={() => reopenMutation.reset()}
        />
      )}
    </>
  )
}
